import { QueryRunnerDemo } from '../features/yesql';

/** The whole app: YesQL filling the viewport edge-to-edge. */
export function YesqlPage() {
  return (
    <div className="h-dvh w-full overflow-hidden">
      <QueryRunnerDemo />
    </div>
  );
}
